import { mapGetters } from 'vuex';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import staticWelcomeSearch from '../staticwelcomesearch/static-welcome-search.vue';
import mvtPageMenu from '@/common/components/mvtpagemenu/mvt-pagemenu.vue';
import schoolsBreadcrumb from "@/schools/components/schoolsbreadcrumb/schools-breadcrumb.vue";

export default {
  name: 'schoolsState',
  inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: {}
        }
    },
    components: {
        mvtCollapsibleLinks,
        staticWelcomeSearch,
        mvtPageMenu,
        schoolsBreadcrumb
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        schoolSrc() {
          return this.glb.cdnUrl + 'images/desktop/schools_static.png';
        },
        schoolTitle() {
          return this.data.stateName + ' Schools';
        },
        getBreadCrumbData() {
          return this.data.breadCrumb;
        }
    },
    methods: {
        formatDataList(list) {
            return list && list.map(item => {
                const url = `${this.glb.appUrl}${item.nameForUrl}`;
                const text = `${item.displayName} ${item.schoolCount ? ` <span class="f7">(${city.schoolCount})</span>` : ''}`
                return {
                    multipart: true,
                    parts: [{ url, text }],
                }
            });
        },
    },
};